import { Col, Row, Typography } from 'antd';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { MenuItem } from '../../hooks/use-menu-items';
import UseNavigateHeaderLinks from '../../hooks/use-navigate-header-links';
import MainMenuIcon from '../main-menu-icon/main-menu-icon';
import { getIconStyles, getLabelStyles } from '../utils/utils';
import styles from './main-menu-collapse-header.module.css';

interface Props {
  menuItem: MenuItem;
  activeMenuItem: MenuItem | undefined;
  tabletIcon?: ReactNode;
  toggleTabletSubMenu?: () => void;
}

const MainMenuCollapseHeader = ({ menuItem, activeMenuItem, tabletIcon, toggleTabletSubMenu }: Props): JSX.Element => {
  const navigateHeaderLinks = UseNavigateHeaderLinks();

  return (
    <Row align="middle" gutter={12} wrap={false}>
      <Col onClick={() => navigateHeaderLinks(menuItem)}>
        <div className={clsx(styles.drawerItem, getIconStyles(menuItem, activeMenuItem))}>
          <MainMenuIcon menuItemIcon={menuItem.icon} />
          <Typography className={getLabelStyles(menuItem, activeMenuItem)}>{menuItem.label}</Typography>
        </div>
      </Col>
      <Col flex="auto" onClick={toggleTabletSubMenu}>
        {tabletIcon}
      </Col>
    </Row>
  );
};

export default MainMenuCollapseHeader;
